import { I18n } from '@/services/i18n';

type Message = {
  activated: string;
  popularity: string;
  turnOff: string;
  ok: string;
};

const messages: I18n<Message> = {
  en: {
    activated: 'Smart Match AI activated successfully!',
    popularity: 'Your popularity is about to take off. 🚀',
    turnOff: 'You can turn off Smart Match AI anytime in settings.',
    ok: 'OK',
  },
  es: {
    activated: '¡Smart Match AI activado con éxito!',
    popularity: '',
    turnOff: '',
    ok: '',
  },
  de: {
    activated: 'Smart Match AI erfolgreich aktiviert!',
    popularity: 'Deine Beliebtheit wird jetzt steigen. 🚀',
    turnOff: 'Du kannst Smart Match AI jederzeit in den Einstellungen deaktivieren.',
    ok: 'OK',
  },
};

export { messages };
